import { render, staticRenderFns } from "./AllSurveys.vue?vue&type=template&id=e552554c&"
import script from "./AllSurveys.vue?vue&type=script&lang=js&"
export * from "./AllSurveys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports